import { useLocation } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';

import { findBreadcrumb } from '@/lib/navigation';

/**
 * Breadcrumb trail derived from the nav config. Rendered at the top of the
 * page content area (not in the header).
 */
export function Breadcrumbs() {
  const location = useLocation();
  const crumb = findBreadcrumb(location.pathname);
  if (!crumb) return null;

  const parts = [crumb.section, crumb.item, ...(crumb.child ? [crumb.child] : [])];

  return (
    <nav aria-label="Breadcrumb" className="text-sm">
      <ol className="flex items-center gap-1.5">
        {parts.map((part, index) => {
          const isLast = index === parts.length - 1;
          return (
            <li key={part} className="flex items-center gap-1.5">
              {index > 0 && (
                <ChevronRightIcon aria-hidden className="text-muted-foreground size-3.5" />
              )}
              <span
                aria-current={isLast ? 'page' : undefined}
                className={isLast ? 'text-foreground font-medium' : 'text-muted-foreground'}
              >
                {part}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
